(($) => {
    const cc = document.querySelector('.container-cookies');
    //if (!cc) return;
    
   // Force drupal cache
   let cachedCookie;
   if(cachedCookie = getCookie('pcGdpr')){
       cc.style.display = 'none';
       const data = JSON.parse(atob(cachedCookie));
       return parseAndExecuteTrackingTags(data);
   }
    
    // Source for cookie functions: https://plainjs.com/javascript/utilities/set-cookie-get-cookie-and-delete-cookie-5/
        // Set cookie.
        function setCookie(name, value, days) {
            var d = new Date;
            d.setTime(d.getTime() + 24*60*60*1000*days);
            document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
        }

    // Get cookie.
        function getCookie(name) {
            var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
            return v ? v[2] : null;
        }

    // Delete cookie.
        function deleteCookie(name) { setCookie(name, '', -1) }
    // End cookie functions


    // Parse and Execute Tracking Tags (if they are currently freezed)
        function parseAndExecuteTrackingTags (data) {
            const allTags = document.querySelectorAll('[pcCookie]');
        
            Array.prototype.forEach.call(allTags, (tag, i) => {
                const hasContent = !!tag.innerHTML.replace(/[\s\t\r\n]+/g, '').length;
                const type = tag.getAttribute('pcTrackingType');
                
                if (!data[type]) {
                    // if tracking type not accepted, cancel this tag
                    if (i == allTags.length - 1) deletePcTags(allTags);
                    return;
                }
        
                const scr = document.createElement('script');
        
                for (let i = 0; i < tag.attributes.length; i++) {
                    let n = tag.attributes[i].name;
                    let v = tag.attributes[i].value;
        
                    if (n.indexOf('pc') == 0) continue;
        
                    if (n == 'data-src') n = 'src';
                    if (~v.indexOf('plain')) v = 'text/javascript';
        
                    scr.setAttribute(n, v);
                }
        
                scr.innerHTML = tag.innerHTML;
        
                tag.insertAdjacentElement('afterend', scr);
        
                if (i == allTags.length - 1) deletePcTags(allTags);
            });
        
            function deletePcTags (allTags) {
                Array.prototype.forEach.call(allTags, (el) => {
                    el.parentElement.removeChild(el);
                });
            }
        }
    // End parseAndExecuteTrackingTags


    // Settings validation
        function getModalValues () {
            const inputList = document.querySelectorAll('.cookies--settings input');

            const data = {};
        
            Array.prototype.forEach.call(inputList, (el) => {
                data[el.name.replace('pcCookieType:', '')] = el.checked;
            });
                
            parseAndExecuteTrackingTags(data);
        
            return data;
        }
        
        function validateCookies () {
            setCookie(
                'pcGdpr',
                btoa(
                    JSON.stringify(getModalValues())
                ),
                180
            );
        }
    // End settings validation

    cc.querySelector('.accept').addEventListener('click', (e) => {
        e.preventDefault();

        validateCookies();

        if (window.$) $(".cookies").fadeOut("slide");
        else cc.parentElement.removeChild(cc);
    });


    cc.querySelector('.save').addEventListener('click', (e) => {
        e.preventDefault();
        cc.querySelector('.accept').click();
    });


    cc.querySelector('.cookies--choice').addEventListener('click', (e) => {
        e.preventDefault();

        if (window.$) {
            $(".cookies--infos").fadeOut("slide");
            $(".cookies--settings").fadeIn("slide");
        } else {
            document.querySelector(".cookies--infos").style.display = 'none';
            document.querySelector(".cookies--settings").style.display = 'block';
        }
    });
    
})();